export const api_base = 'https://admin.qa.ezyerp.net/api/v1';
export const mobile = '97450416493';
export const currency = 'QA';
export const metaTitle = (title = '') => {
    if(title !== ''){
        title = ' | '+title;
    }
    return "ezyERP"+title;
}